import api from './api';

export interface WhatsappTemplate {
  _id?: string;
  name: string;
  content: string;
  createdAt?: string;
  updatedAt?: string;
}

class WhatsappTemplateService {
  // Tüm şablonları getir
  async getTemplates(): Promise<WhatsappTemplate[]> {
    try {
      const response = await api.get('/whatsapp-templates');
      if (response.data.success && response.data.data) {
        return response.data.data;
      }
      return [];
    } catch (error) {
      console.error('❌ Error fetching whatsapp templates:', error);
      return [];
    }
  }

  // Yeni şablon oluştur
  async createTemplate(templateData: Omit<WhatsappTemplate, '_id'>): Promise<WhatsappTemplate | null> {
    try {
      const response = await api.post('/whatsapp-templates', templateData);
      if (response.data.success && response.data.data) {
        return response.data.data;
      }
      return null;
    } catch (error) {
      console.error('❌ Error creating whatsapp template:', error);
      throw error;
    }
  }

  // Şablon güncelle
  async updateTemplate(id: string, templateData: Omit<WhatsappTemplate, '_id'>): Promise<WhatsappTemplate | null> {
    try {
      const response = await api.put(`/whatsapp-templates/${id}`, templateData);
      if (response.data.success && response.data.data) {
        return response.data.data;
      }
      return null;
    } catch (error) {
      console.error('❌ Error updating whatsapp template:', error);
      throw error;
    }
  }

  // Şablon sil
  async deleteTemplate(id: string): Promise<boolean> {
    try {
      const response = await api.delete(`/whatsapp-templates/${id}`);
      return response.data.success;
    } catch (error) {
      console.error('❌ Error deleting whatsapp template:', error);
      return false;
    }
  }
}

const whatsappTemplateService = new WhatsappTemplateService();
export default whatsappTemplateService;
